import React, { useState } from 'react'
import { Page, Card } from '@shopify/polaris';
import { useSelector, useDispatch } from 'react-redux'
import RenderPurchaseOrderList from '../RenderPurchaseOrderList';
import Loader from '../../Loader';
import axios from 'axios';
import './style.css'
import actionTypes from '../../../store/actionTypes';
import EmptyList from '../../EmptyList';

const PurchaseOrderList = props => {
    const { savePurchaseOrders } = actionTypes

    const { serverLink, shopDomain } = useSelector(state => state.ConfigReducer)
    const { purchaseOrders, fetchingPos } = useSelector(state => state.POReducer)
    const dispatch = useDispatch()

    const [OrderGenerating, setOrderGenerating] = useState(false)

    const generatePurchaseOrders = () => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setOrderGenerating(true)
            const options = {
                method: 'GET',
                url: `${serverLink}/order/${shopDomain}`,
            }
            axios(options)
                .then(({ data }) => {
                    setOrderGenerating(false)
                    if (data !== 'No Active order') {
                        dispatch({ type: savePurchaseOrders, payload: data.concat(purchaseOrders) })
                    } else {
                        alert(data)
                        console.log(data);
                    }
                })
                .catch(error => {
                    setOrderGenerating(false)
                    console.log("error", error)
                    alert(error)
                })
        } else {
            alert("Please, Check Your Internet Connection!")
        }
    }

    const orderLoadingStyle = {
        width: "100px",
        height: "100px",
        margin: "10px auto",
        borderWidth: "12px",
        borderStyle: "double solid solid",
        borderColor: '#008060',
    }

    // const orderGeneratingStyle = {
    //     width: "20px",
    //     height: "20px",
    //     borderWidth: "2px",
    //     borderStyle: "solid",
    //     borderColor: "#008060 white white",
    // }
    return fetchingPos ? <Loader style={orderLoadingStyle} /> : (purchaseOrders.length > 0 ? <Page
        fullWidth
        title="Purchase Orders"
        primaryAction={{
            content: 'Reload',
            onAction: () => window.location.reload()
            // content: OrderGenerating ? <Loader style={orderGeneratingStyle} /> : 'Generate POs',
            // onAction: () => generatePurchaseOrders()
        }}
    >
        <Card sectioned subdued>
            <table className="tblOrders">
                <thead className="tblHead">
                    <tr>
                        <th>PO #</th>
                        <th>Supplier</th>
                        <th>Time Until Cutoff</th>
                        <th>Cost</th>
                        <th>Cost + VAT</th>
                        <th>Notes</th>
                        <th>Status</th>
                        <th>Submitted At</th>
                        <th>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    <RenderPurchaseOrderList purchaseOrders={purchaseOrders} />
                </tbody>
            </table>
        </Card>
    </Page > : <Page><EmptyList OrderGenerating={OrderGenerating} generatePurchaseOrders={generatePurchaseOrders} /></Page>)
}

export default PurchaseOrderList
